import { getMsalConfiguration } from '../../authorization/authorization';
import { UserManagementRoute } from '../../routes/routes';
import { getCurrentIdToken } from '../authentication/authenticationService';
import { getMsalInstance } from '../authentication/msalInstance';
import { logLogout } from '../sessionService';

export const getCurrentUrlData = () => {
  const hrefData = window.location.href.split('#');
  if (hrefData && hrefData.length > 0) {
    return hrefData[1];
  }
  return '';
};

export const getRelativeUrlData = (): QueryStringData | undefined => {
  const dataString =
    window.location.search.length > 0
      ? window.location.search
      : window.location.href.split('#')[1];

  if (dataString) {
    const tokenData = getQueryStringData(dataString);
    if (tokenData.id_token || tokenData.switchTo) {
      return tokenData;
    }
  }
  return undefined;
};

export const redirectToUrl = (url: string) => {
  window.location.replace(url);
};

export const goToUrl = (url: string) => {
  window.location.href = url;
};

export const clearUrl = () => {
  window.location.href = window.location.origin + window.location.pathname;
};

export const clearUrlData = () => {
  window.location.replace(window.location.href.split('#')[0]);
};

export const getCurrentHash = () => {
  const hash = `${window.location.hash}`;
  window.location.hash = '';
  return hash && hash.length > 0 ? hash : '';
};

interface QueryStringData {
  noRedirect: boolean;
  id_token: string | null;
  switchTo: string | null;
}

export const getQueryStringData = (
  locationSearchParam: string
): QueryStringData => {
  let locationSearch = locationSearchParam;

  const questionMarkCount = locationSearchParam.split('?').length - 1;

  if (questionMarkCount > 1) {
    const searchNoStartQuestion = locationSearch.substring(1);
    const searchReplacedQuestion = searchNoStartQuestion.replace('?', '&');
    locationSearch = `?${searchReplacedQuestion}`;
  }

  const queryParams = new URLSearchParams(locationSearch);
  return {
    id_token: queryParams.get(LocationConstants.ID_TOKEN_IDENTIFIER),
    switchTo: queryParams.get(LocationConstants.SWITCH_TO_IDENTIFIER),
    noRedirect: queryParams.has(LocationConstants.NO_REDIRECT),
  };
};

export const getDefaultLocation = (
  initialLocation: string | undefined
): string => {
  if (initialLocation === '/') {
    return UserManagementRoute.path;
  } else if (initialLocation && initialLocation.split('/')[1]) {
    return initialLocation;
  } else {
    return UserManagementRoute.path;
  }
};

export const LocationConstants = {
  ID_TOKEN_IDENTIFIER: 'id_token',
  SWITCH_TO_IDENTIFIER: 'switchTo',
  EXPIRES_IN_IDENTIFIER: 'expires_in',
  NO_REDIRECT: 'no_redirect',
};

export const navigateToPortalUrl = (portaUrl: string) => {
  const tokenQuerystring = `?${
    LocationConstants.ID_TOKEN_IDENTIFIER
  }=${getCurrentIdToken()}`;
  const portalUrlToken = `${portaUrl}${tokenQuerystring}`;
  goToUrl(portalUrlToken);
};

export const signOut = (saveLogLogout: boolean = false) => {
  const logOut = () => {
    getMsalInstance().then((msalInstance) => {
      msalInstance.logoutRedirect({
        authority: getMsalConfiguration().auth.authority,
      });
    });
  };

  if (saveLogLogout) {
    logLogout().finally(() => {
      logOut();
    });
  } else {
    logOut();
  }
};
